import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {AUTH_TOKEN} from "../../constants/AuthConstant";
import Cookies from "js-cookie";
import shiftService from "../../services/shiftService";

export const initialState = {
    loading_shift: false,
    data_shift: [],
    data_import: [],
    showMessage:false,
    message:'',
}


export const getDataShift = createAsyncThunk('shift/data',async (data, { rejectWithValue }) => {
    try {
        const response = await shiftService.data(Cookies.get(AUTH_TOKEN),data)
        return response
    } catch (err) {
        //message.error(err.response?.data?.message || 'Error',3)
    }
})

export const getaDataImport = createAsyncThunk('shift/dataimport',async (data, { rejectWithValue }) => {
    try {
        const response = await shiftService.data_import(Cookies.get(AUTH_TOKEN))
        return response
    } catch (err) {
    }
})

export const emptyDataImport = createAsyncThunk('shift/emptyimport',async (data, { rejectWithValue }) => {
    try {
        const response = await shiftService.empty_import(Cookies.get(AUTH_TOKEN))
        return response
    } catch (err) {
    }
})

export const saveDataImport = createAsyncThunk('shift/saveimport',async (data, { rejectWithValue }) => {
    try {
        const response = await shiftService.save_import(Cookies.get(AUTH_TOKEN))
        return response
    } catch (err) {
    }
})


export const shiftSlice = createSlice({
    name: 'shift',
    initialState,
    reducers: {
        showLoading: (state) => {
            state.loading_shift = true
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getDataShift.fulfilled, (state, action) => {
                state.loading_shift = false
                state.data_shift = action.payload??[]
            })
            .addCase(getDataShift.pending, (state) => {
                state.loading_shift = true
            })
            .addCase(getDataShift.rejected, (state, action) => {
                state.loading_shift = false
                state.data_shift = action.payload??[]
            })
            .addCase(getaDataImport.fulfilled, (state, action) => {
                state.loading_shift = false
                state.data_import = action.payload??[]
            })
            .addCase(getaDataImport.pending, (state) => {
                state.loading_shift = true
            })
            .addCase(getaDataImport.rejected, (state, action) => {
                state.loading_shift = false
                state.data_import = action.payload??[]
            })

    },
})

export const {
    showLoading,
} = shiftSlice.actions

export default shiftSlice.reducer
